import { faCheck, faCircleXmark, faClock, faPenToSquare, faPlus, faPrint, faTrashCan, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AgGridReact } from 'ag-grid-react'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import AddRequest from '../AddRequest/AddRequest';
import { FormControl, InputLabel, MenuItem, Select, Skeleton, TextField, ThemeProvider } from '@mui/material';
import Button from '@mui/material/Button';
import moment from 'moment';
import SuccessMessage from '../SuccessMessage/SuccessMessage';
import ConfirmedMessage from '../ConfirmedMessage/ConfirmedMessage';
import { useApi } from '../Store/ApiContext';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { changeError } from '../../constants/global';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import ConfirmedMessageWithReason from '../ConfirmedMessageWithReason/ConfirmedMessageWithReason';
import RequestsStats from '../RequestsStats/RequestsStats';
import { PrintReceiptModal } from '../receipts/PrintReceiptModal';
import { CheckoutRequestModal } from '../checkout/CheckoutRequestModal';

export default function Requests({ theme, token, baseUrl, togglePopUp, popupClose, decodeToken, tableContainerStyle, organizationAuthorization }) {

  const { getData, confirmRemove, quickEditTable, getSlug, quickEditDiscountStatus, ProtectedComponentRoles } = useApi();
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const gridRef = useRef(); // Optional - for accessing Grid's API
  const filterTextBox = useRef(); //  input text box

  const [rowData, setRowData] = useState(null); // Set rowData to Array of Objects, one Object per Row

  const [numberOfRows, setNumberOfRows] = useState(20);
  const [idRequestRow, setIdRequestRow] = useState();
  const [requestDataRow, setRequestDataRow] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [data, setData] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  // Print modal state
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [selectedRequestForPrint, setSelectedRequestForPrint] = useState(null);
  // Checkout modal state
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [selectedRequestForCheckout, setSelectedRequestForCheckout] = useState(null);
  const [bookingPolicies, setBookingPolicies] = useState({});

  // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([
    { field: 'reqCode', headerName: t("Request Code"), width: 150 },
    {
      field: 'reqStatus', headerName: t("Request Status"), width: 150,
      // editable: (params) => params.data.reqStatus === "started" || params.data.reqStatus === "finished" ? false : true,
      cellEditor: 'agSelectCellEditor',
      cellRenderer: params => {
        const styles = handleRequestStatusColored(params.data.reqStatus);
        if (["pending"].includes(params.data.reqStatus)) {
          return <>
            <span className={`px-2 me-3 ${styles.bg} ${styles.text}`} style={{ borderRadius: "10px" }}>
              {t(params.data.reqStatus)}
            </span>
            <ProtectedComponentRoles plans={["go"]} roles={["General Manager", "Front Office Agent"]}>
              <span
                className=""
              >
                <FontAwesomeIcon className='cursor-pointer fs-6 text-success' icon={faCheck} onClick={() => quickEditTable("request", { reqStatus: "confirmed" }, params.data._id, setRowData)} />
              </span>
            </ProtectedComponentRoles>
          </>
        } else {
          return <>
            <span className={`px-2 me-3 ${styles.bg} ${styles.text}`} style={{ borderRadius: "10px" }}>
              {t(params.data.reqStatus)}
            </span>
          </>
        };

      },
      // cellEditorParams: {
      //   values: [t("pending"), t("settled"), t("rejected")],
      // },
    },
    {
      field: 'discountRequest.discountStatus', headerName: t("discountStatus"), width: 160,
      cellEditor: 'agSelectCellEditor',
      cellRenderer: params => {
        const styles = handleDiscountRequestStatusColored(params.data.discountRequest?.discountStatus ?? "approved");

        if (["awaiting"].includes(params.data.discountRequest?.discountStatus) && !["rejected", "cancelled"].includes(params.data.reqStatus)) {
          return <>
            <span className={`px-2 me-3 ${styles.bg} ${styles.text}`} style={{ borderRadius: "10px" }}>
              {t(params.data.discountRequest?.discountStatus ?? t("approved"))}
            </span>
            <ProtectedComponentRoles plans={["go"]} roles={['General Manager']}>
              <span
                className=""
              >
                <FontAwesomeIcon className='cursor-pointer fs-6 text-success me-4' icon={faCheck} onClick={() => quickEditDiscountStatus("request", { discountStatus: "approved" }, params.data.discountRequest._id, setRowData)} />
                <FontAwesomeIcon className='cursor-pointer fs-6 text-danger' icon={faXmark} onClick={() => quickEditDiscountStatus("request", { discountStatus: "rejected" }, params.data.discountRequest._id, setRowData)} />
              </span>
            </ProtectedComponentRoles>
          </>
        } else {
          return <>
            <span className={`px-2 ${styles.bg} ${styles.text}`} style={{ borderRadius: "10px" }}>
              {t(params.data.discountRequest?.discountStatus ?? t("approved"))}
            </span>
          </>
        };
      },
    },
    { field: 'reqClientName', headerName: t("Applicant"), width: 200 },
    {
      field: 'clientPhone', headerName: t("Phone Number"), width: 150,
      cellRenderer: function (params) {
        return <a dir="ltr" href={'tel:' + (params.data.client ? params.data.client?.clientPhone : "+" + params.data.rentingUser?.phoneNumber)}>{params.data.client ? params.data.client?.clientPhone : "+" + params.data.rentingUser?.phoneNumber}</a>
      }
    },
    {
      field: 'unit.unitCode', headerName: t("Unit"), width: 300,
      cellRenderer: function (params) {
        return params.data.unit.unitCode + " - " + params.data.unit.unitName
      }
    },
    {
      field: 'reqFrom', headerName: t("From"), width: 180,
      cellRenderer: function (params) {
        return moment(params.data.reqFrom).utc(false).format("L - LTS");
      }
    },
    {
      field: 'reqTo', headerName: t("To"), width: 180,
      cellRenderer: function (params) {
        return moment(params.data.reqTo).utc(false).format("L - LTS");
      }
    },
    { field: 'reqNights', headerName: t("Duration (Days)"), width: 120 },
    // {field: 'unit.cost', headerName : "تكلفة الليلة", width:120, 
    // cellRenderer: function(params) {
    //   if (params.data.unit.costInterval === "month") {
    //     return (params.data.unit.cost / 30.5).toFixed(2)
    //   }else {
    //     return params.data.unit.cost;
    //   }
    // }},
    { field: 'reqTotalCost', headerName: t("Total Cost"), width: 125, editable: false },
    { field: 'discountPercentage', headerName: t("discountPercentage"), width: 125, editable: false },
    {
      field: 'amountPaid',
      headerName: t("amountPaid"),
      width: 100,
      cellRenderer: function (params) {
        return calculateAmountPaid(params.data.reqPayments);
      },
      valueGetter: function (params) {
        return calculateAmountPaid(params.data.reqPayments);
      },
    },
    // { field: 'insurance', headerName: t("Insurance"), width: 100 },
    // {
    //   field: 'paymentMethod', headerName: t("paymentMethod"), width: 130,
    //   cellRenderer: function (params) {
    //     return params.data.paymentMethod ? t(params.data.paymentMethod) : "-";
    //   }
    // },
    { field: 'notes', headerName: t("Notes"), width: 200 },
    {
      field: '', headerName: t("requestFrom"), width: 200, cellRenderer: function (params) {
        return params.data.rentingUser == null && params.data.requestSource === "admin" ? `${t("frontOffice")} (${params.data.createdBy?.userName})` : params.data.rentingUser != null && params.data.requestSource === "listing" ? t("system") : t("ikwti");
      },
      valueGetter: function (params) {
        return params.data.rentingUser == null && params.data.requestSource === "admin" ? `${t("frontOffice")} (${params.data.createdBy?.userName})` : params.data.rentingUser != null && params.data.requestSource === "listing" ? t("system") : t("ikwti");
      },
    },
    // {
    //   field: 'updatedAt', headerName: t("Last Update"), width: 200,
    //   cellRenderer: function (params) {
    //     return moment(params.data.updatedAt).utc(true).format("L - LTS a");
    //   }
    // },
    // getSlug() == "sanmina" ? {
    //   field: '', headerName: t("whatsapp"), width: 100,
    //   cellRenderer: function (params) {
    //     const phoneNumber = params.data.client ? params.data.client?.clientPhone : "+" + params.data.rentingUser.phoneNumber;
    //     return <a target='_blank' href={`https://wa.me/${phoneNumber}?text=${sendWhatsappMessage()}`}>
    //       <FontAwesomeIcon className=' cursor-pointer fs-5 text-success' icon={faWhatsapp} />
    //     </a>;
    //   }
    // } : <></>,
    {
      field: '', headerName: t("Settings"), width: 200,
      cellRenderer: function (params) {
        const phoneNumber = params.data.client ? params.data.client?.clientPhone : "+" + params.data.rentingUser?.phoneNumber;
        console.log(phoneNumber);

        if (!["rejected", "cancelled"].includes(params.data.reqStatus) && !["awaiting"].includes(params.data.discountRequest?.discountStatus)) {
          return <span>
            <FontAwesomeIcon className='mx-2 text-blue-600 cursor-pointer fs-6' onClick={() => {
              setShowPrintModal(true);
              setSelectedRequestForPrint(params.data);
            }}
              icon={faPrint}
            />
            {
              !params.data.checkoutRequest && ["settled", "deposit"].includes(params.data.reqStatus) && moment().isBetween(moment(params.data.reqFrom), moment(params.data.reqTo)) ?
                <FontAwesomeIcon className='mx-2 text-purple-600 cursor-pointer fs-6' onClick={() => {
                  setShowCheckoutModal(true);
                  setSelectedRequestForCheckout(params.data);
                }}
                  icon={faClock}
                /> : <></>
            }
            {
              !["settled", "rejected", "cancelled"].includes(params.data.reqStatus) ?
                <a className='mx-2' target='_blank' href={`https://wa.me/${phoneNumber}?text=${sendWhatsappMessage(params.data)}`}>
                  <FontAwesomeIcon className=' cursor-pointer fs-5 text-success' icon={faWhatsapp} />
                </a> : <></>
            }
            <FontAwesomeIcon className='mx-2 text-orange-400 cursor-pointer fs-6' onClick={() => {
              onSelectionChanged();
            }}
              icon={faPenToSquare}
            />
            {!["rejected", "cancelled"].includes(params.data.reqStatus) ? <FontAwesomeIcon
              className='mx-2 text-danger cursor-pointer fs-6'
              icon={faCircleXmark}
              onClick={
                () => {
                  const amountRefund = calculateAmountPaid(params.data.reqPayments);
                  setRequestDataRow(params.data);
                  setData({ reqStatus: params.data.reqStatus === "pending" ? "rejected" : "cancelled", cancellationReason: null, amountRefund, paymentMethod: "bankTransfer" });
                  confirmRemove(params.data._id, setIdRequestRow)
                }
              }
            /> : null}
          </span>;
        }
      }
    },
  ]);

  // Helper function to calculate amount paid
  const calculateAmountPaid = (reqPayments) => {
    return reqPayments.reduce((total, payment) =>
      payment.paymentType === "deposit" ? total + payment.amountPaid : total - payment.amountPaid, 0
    );
  };

  // function ProtectedComponentsProPlan(props) { // shield for pro components
  //   if (localStorage.getItem("token")) {
  //     const decoded = decodeToken();
  //     if (decoded.planName === "pro") {
  //       return props.children;
  //     } else {
  //       return <></>
  //     }
  //   }
  // }

  function ProtectedComponentsProPlan(props) { // shield for pro components
    if (localStorage.getItem("token")) {
      if (organizationAuthorization.plan.planName === "pro") {
        return props.children;
      } else {
        return <></>;
      }
    }
  }

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    // flex: 1,
    minWidth: 100,
    sortable: true,
    filter: true,
    resizable: true,
  }));

  // Example of consuming Grid Event
  const cellClickedListener = useCallback(event => {
    ////('cellClicked', event);
  }, []);


  // selection rows
  const onSelectionChanged = useCallback(() => {
    let selectedRows = gridRef.current.api.getSelectedRows();
    console.log(selectedRows);
    // setRequestDataRow(selectedRows[0])
    navigate("/edit-request", { state: selectedRows[0] });
  }, []);

  // filter table
  const onFilterTextBoxChanged = useCallback((e) => {
    gridRef.current.api.setQuickFilter(
      e.target.value
    );
  }, []);



  const handleChange = (event) => {
    setNumberOfRows(event.target.value);
  };

  async function changeRequestsStatus() {
    const { data } = await axios({
      url: `${baseUrl}request/changeRequestsAccepted`,
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        "authorization": `Bearer ${token}`,
      }
    })
    console.log(data);
    if (data) {
      getData(setRowData, "request");
    }
  }



  function handleSaveRequestStatusEnglish(requestStatus) {
    let newRequestStatus
    switch (requestStatus) {
      case t("pending"):
        newRequestStatus = "pending"
        break;
      case t("settled"):
        newRequestStatus = "settled"
        break;
      case t("rejected"):
        newRequestStatus = "rejected"
        break;
      default:
        break;
    }
    return { reqStatus: newRequestStatus }
  }

  function handleRequestStatusColored(requestStatus) {
    const statusStyles = {
      pending: {
        bg: 'bg-yellow-100',
        text: 'text-yellow-800'
      },
      confirmed: {
        bg: 'bg-blue-100',
        text: 'text-blue-800'
      },
      deposit: {
        bg: 'bg-purple-100',
        text: 'text-purple-800'
      },
      settled: {
        bg: 'bg-green-100',
        text: 'text-green-800'
      },
      cancelled: {
        bg: 'bg-orange-100',
        text: 'text-orange-800'
      },
      rejected: {
        bg: 'bg-red-100',
        text: 'text-red-800'
      },
      awaiting: { // Add this
        bg: 'bg-orange-100',
        text: 'text-orange-800'
      }
    };

    return statusStyles[requestStatus] || { bg: 'bg-slate-100', text: 'text-slate-800' };
  }

  function handleDiscountRequestStatusColored(discountRequestStatus) {
    const discountRequestStatusStyles = {
      awaiting: {
        bg: 'bg-orange-100',
        text: 'text-orange-800'
      },
      approved: {
        bg: 'bg-green-100',
        text: 'text-green-800'
      },
      rejected: {
        bg: 'bg-red-100',
        text: 'text-red-800'
      }
    };

    return discountRequestStatusStyles[discountRequestStatus] || { bg: 'bg-slate-100', text: 'text-slate-800' };
  }

  const saveStatus = async (id, newData, data) => {
    const res = await quickEditTable(`request`, newData, `${id}?startDate=${data.reqFrom}&unit=${data.unit._id}`)
    if (res.message) {
      enqueueSnackbar(<>{changeError}<br />{t(res.message)}</>, { variant: "error" });
      getData(setRowData, "request");
    }
  };
  const onCellValueChanged = useCallback((params) => {
    let newData = {}
    newData[params.column.getId()] = params.newValue;
    console.log(newData);
    if (params.column.getId() === 'reqStatus') {
      if (i18n.language !== "en") {
        let newRequestStatus = handleSaveRequestStatusEnglish(newData.reqStatus)
        saveStatus(params.data._id, newRequestStatus, params.data)
      } else {
        saveStatus(params.data._id, newData, params.data)
      }
    }
  }, []);

  const sendWhatsappMessage = (request) => {
    if (!request) return "";

    const message = `
      مـرحـبــا ${request.reqClientName}
      بيت مصيف كنيسة مارمينا المندرة يرحب بكم

       تم الحجز
      مسلسل حجز رقم : ${request.reqCode} 
      من يوم ${request.reqFrom ? moment(request.reqFrom).format("YYYY/MM/DD") : ""} بعدد ليالى ${request.reqNights}
      فى عمارة ${request.unit?.unitName ?? ""} رقم الوحدة ${request.unit?.unitCode ?? ""}
      الحجز غير شامل الوجبات

      بإجمالي مستحق ${request.reqTotalCost} ج.م.

      يرجى الاطلاع علي تفاصيل وحدتك المختارة
      عدد الغرف ${request.unit?.bedrooms ?? ""}
      عدد الافراد ${request.reqGuests}
      قيمة الإيجار اليومي للوحدة * ${(request.reqTotalCost / request.reqNights).toFixed(2) ?? ""}ج.م./ليلة*

      وصف و كماليات الوحدة
      ${request.organization?.listingUrl ?? request.organization?.slug + ".egarhub.com"}/unit/${request.unit?._id}

      بعض الشروط العامة للمكان

      تسجيل الدخول فى تمام الساعة (12) ظهراً
      تسجيل الخروج فى تمام الساعة (10) صباحا
      ممنوع إصطحاب الحيوانات الاليفة
      ممنوع إدخال المشروبات الكحولية بكل انواعها حرصاً على عدم الــلإحــراج

      ملحوظة هامة
      فى حال الغاء الحجز فى فترة زمنية اقل من 21 يوم من تاريخ الاقامة, لا يتم استرجاع اياً من المدفوعات السابقة و لا يسمح بنقل المدفوعات لحجز اخر
      عدم امكانيه تسكين افراد بدون بطايق
      بالنسبه للمتزوجين احضار قسيمه الزواج في حاله عدم وجود اسم الزوج في بطاقه الزوجه

      *يرجى إرسال نصف قيمة الحجز عن طريق:*

      ايداع بنكى فى حساب الكنيسة فى بنك (CIB)
      بإسم: كنيسة مارمينا المندرة_فرع ميامي
      رقم: 100015739252
      ..
      حوالة بريدية
      بإسم: هانى ميشيل بلامون واصف
      26011011200052

      *يرجي التأكيد علي هذه الرساله بالموافقه لأكتمال الحجز*
    `;
    return encodeURIComponent(message);
  }

  // Filter and sort logic
  const filteredRequests = useMemo(() => {
    if (rowData?.length) {

      console.log(rowData);

      return rowData.filter(request => {
        let matchesStatus;

        if (statusFilter === 'awaiting') {
          // Special handling for awaiting status - check discountRequest.discountStatus
          matchesStatus = request.discountRequest?.discountStatus === 'awaiting';
        } else {
          // Normal status filtering
          matchesStatus = statusFilter === 'all' || request.reqStatus === statusFilter;
        }

        return matchesStatus;
      });
    }

  }, [rowData, statusFilter]);

  // const sortedRequests = useMemo(() => {
  //   return [...filteredRequests].sort((a, b) => {
  //     let aValue, bValue;

  //     if (sortBy === 'createdAt') {
  //       aValue = new Date(a.createdAt).getTime();
  //       bValue = new Date(b.createdAt).getTime();
  //     } else {
  //       aValue = parseInt(a.id);
  //       bValue = parseInt(b.id);
  //     }

  //     return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
  //   });
  // }, [filteredRequests, sortBy, sortOrder]);

  const handleStatusFilterChange = (status) => {
    setStatusFilter(status);
    // Reset to first page when filter changes
    if (gridRef.current) {
      gridRef.current.api.paginationGoToPage(0);
    }
  };

  // Example load data from server
  useEffect(() => {
    // add title page
    document.title = t("Requests");
    getData(setRowData, "request");
  }, []);



  // Status counts
  const statusCounts = useMemo(() => {
    if (rowData?.length) {
      return {
        all: rowData.length,
        pending: rowData.filter(r => r.reqStatus === 'pending').length,
        confirmed: rowData.filter(r => r.reqStatus === 'confirmed').length,
        deposit: rowData.filter(r => r.reqStatus === 'deposit').length,
        settled: rowData.filter(r => r.reqStatus === 'settled').length,
        cancelled: rowData.filter(r => r.reqStatus === 'cancelled').length,
        rejected: rowData.filter(r => r.reqStatus === 'rejected').length,
        awaiting: rowData.filter(r => r.discountRequest?.discountStatus === 'awaiting').length, // Add this line
      };
    }
  }, [rowData]);

  // Load booking policies from backend
  const loadBookingPolicies = async () => {
    try {
      const bookingPolicies = sessionStorage.getItem("bookingPolicies");
      if (bookingPolicies) {
        setBookingPolicies(JSON.parse(bookingPolicies));
      } else {
        const response = await getData(null, 'bookingPolicies');
        if (response && response.results) {
          setBookingPolicies(response.results.bookingPolicies);
          sessionStorage.setItem("bookingPolicies", JSON.stringify(response.results.bookingPolicies));
        }
      }
    } catch (error) {
      console.error('Error loading booking policies:', error);
      enqueueSnackbar(t('error.loadingFailed') || 'Failed to load policies', { variant: 'error' });
    }
  };

  useEffect(() => {
    loadBookingPolicies();
  }, []);


  return (
    <>
      <section className='bg-babyblue-50 big-card container-fluid'>
        <div className="header-card d-flex justify-content-between align-items-center">
          <div className="header-title">
            <h2 className='fw-bolder'>{t("Requests")}</h2>
          </div>
          <ProtectedComponentsProPlan>
            {/* <div onClick={() => { togglePopUp("add-popup"); setShowPopup(true); window.history.replaceState("", "Title", "#add-request"); }}>
              <Button variant="contained" className='btn-request'><span className='me-2 '><FontAwesomeIcon icon={faPlus} /></span>{t("Add request")}</Button>
            </div> */}
            <div>
              <Link to={"/add-request"}><Button variant="contained" className='btn-request'><span className='me-2 '><FontAwesomeIcon icon={faPlus} /></span>{t("Add request")}</Button></Link>
            </div>
          </ProtectedComponentsProPlan>
        </div>
        {rowData && <div className='filtter-requests pt-4 pb-2 px-2 mx-3'>
          <RequestsStats
            statusCounts={statusCounts}
            statusFilter={statusFilter}
            onStatusFilterChange={(status) => handleStatusFilterChange(status)}
          />
        </div>}
        {rowData ? <div className='table-unites py-3 px-2 mx-3'>

          {/* Search table and inputs number of rows */}
          <div className="header-table mb-3 d-flex justify-content-between align-items-center">
            <ThemeProvider theme={theme}>
              <div className="inputs-number-rows">

                <FormControl sx={{ m: 1, minWidth: 100 }} size="small" fullWidth>
                  <InputLabel id="demo-simple-select-label">{t("Entries No.")}</InputLabel>
                  <Select
                    MenuProps={{ disableScrollLock: true }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={numberOfRows}
                    label={t("Entries No.")}
                    onChange={handleChange}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={40}>40</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={60}>60</MenuItem>
                    <MenuItem value={70}>70</MenuItem>
                    <MenuItem value={80}>80</MenuItem>
                    <MenuItem value={90}>90</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>

              </div>
              <div className='header-table-search d-flex align-items-end justify-content-end flex-wrap'>
                {/* <Button variant="contained" className='btn-small-request mx-4' style={{ fontSize: "12px" }} onClick={changeRequestsStatus}>{t("Update Status")}</Button> */}
                <TextField id="filter-text-box" label={t("Search...")} variant="standard" ref={filterTextBox} onInput={onFilterTextBoxChanged} />
              </div>
            </ThemeProvider>
          </div>

          {/* Example using Grid's API */}

          {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
          <div className="ag-theme-alpine" style={tableContainerStyle}>

            <AgGridReact
              enableRtl={i18n.language === 'ar' ? true : false}
              ref={gridRef} // Ref for accessing Grid's API

              rowData={filteredRequests} // Row Data for Rows
              onCellValueChanged={onCellValueChanged}
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties

              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
              rowSelection='single' // Options - allows click selection of rows

              onCellClicked={cellClickedListener} // Optional - registering for Grid Event
              paginationPageSize={numberOfRows}
              pagination={true}
              rowHeight={40}
            />
          </div>

        </div> : <div className='pt-4 pb-3 px-2 mx-3'>
          <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4 mb-6'>
            <Skeleton variant="rounded" width={"100%"} height={"100px"} style={{ borderRadius: "10px" }} />
            <Skeleton variant="rounded" width={"100%"} height={"100px"} style={{ borderRadius: "10px" }} />
            <Skeleton variant="rounded" width={"100%"} height={"100px"} style={{ borderRadius: "10px" }} />
            <Skeleton variant="rounded" width={"100%"} height={"100px"} style={{ borderRadius: "10px" }} />
            <Skeleton variant="rounded" width={"100%"} height={"100px"} style={{ borderRadius: "10px" }} />
            <Skeleton variant="rounded" width={"100%"} height={"100px"} style={{ borderRadius: "10px" }} />
            <Skeleton variant="rounded" width={"100%"} height={"100px"} style={{ borderRadius: "10px" }} />
            <Skeleton variant="rounded" width={"100%"} height={"100px"} style={{ borderRadius: "10px" }} />
          </div>
          <div className='d-flex justify-content-between mb-2'>
            <Skeleton variant="rounded" width={"150px"} height={"50px"} style={{ borderRadius: "10px" }} />
            <Skeleton variant="rounded" width={"200px"} height={"50px"} style={{ borderRadius: "10px" }} />
          </div>
          <Skeleton variant="rounded" width={"100%"} height={"70vh"} style={{ borderRadius: "10px" }} />
        </div>}
      </section>

      {/* popup */}
      <div className='add-popup'>
        <AddRequest theme={theme} baseUrl={baseUrl} togglePopUp={togglePopUp} popupClose={popupClose} requestDataRow={requestDataRow} setRequestDataRow={setRequestDataRow} setRowData={setRowData} showPopup={showPopup} setShowPopup={setShowPopup} requestsData={rowData} />
      </div>

      {/* Success Message */}
      {/* <div>
      <ThemeProvider theme={theme}>
        <SuccessMessage message={successMessageRemove} showSuccess={showSuccessRemove} setShowSuccess={setShowSuccessRemove} />
        <ErrorMessage message={errorMessageRemove} showError={showErrorRemove} setShowError={setShowErrorRemove}/>
        <SuccessMessage message={successMessage} showSuccess={showSuccess} setShowSuccess={setShowSuccess} />
      </ThemeProvider>
    </div> */}

      <div className='add-confirm'>
        <ConfirmedMessageWithReason customTheme={theme} token={token} baseUrl={baseUrl} togglePopUp={togglePopUp} popupClose={popupClose} id={idRequestRow} setRowData={setRowData} requestDataRow={requestDataRow} endPoint={"request"} actionText={data?.reqStatus !== null ? data?.reqStatus === "rejected" ? "reject" : "cancel" : "delete"} setData={setData} data={data} />
      </div>
      {/* Print Invoice Modal */}
      {selectedRequestForPrint && (
        <PrintReceiptModal
          isOpen={showPrintModal}
          onClose={() => {
            setShowPrintModal(false);
            setSelectedRequestForPrint(null);
          }}
          type="invoice"
          request={selectedRequestForPrint}
        />
      )}
      {/* Checkout Request Modal */}
      {selectedRequestForCheckout && (
        <CheckoutRequestModal
          isOpen={showCheckoutModal}
          onClose={() => {
            setShowCheckoutModal(false);
            setSelectedRequestForCheckout(null);
          }}
          withConfirm={() => {
            getData(setRowData, "request");
          }}
          request={selectedRequestForCheckout}
          bookingPolicies={bookingPolicies}
          t={t}
        />
      )}
    </>
  )
}